import { LangProps, TPAComponentProps } from '../../types';

export enum CheckboxGroupLayout {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
export interface CheckboxGroupProps extends TPAComponentProps, LangProps {
  label?: string | React.ReactNode;
  children?: any;
  layout?: CheckboxGroupLayout;
  error?: boolean;
  newErrorMessage?: boolean;
  errorText?: string;
  disabled?: boolean;
  fluid?: boolean;
  'data-hook'?: string;
}

export interface CheckboxGroupDefaultProps {
  layout: CheckboxGroupLayout;
}
